import { render, staticRenderFns } from "./DepartmentPicker.vue?vue&type=template&id=3dba242a&"
import script from "./DepartmentPicker.vue?vue&type=script&lang=js&"
export * from "./DepartmentPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports